import { HIDE_BOOKING_FAILURE } from "./types";

const hideBookingFailure = () => ({
  type: HIDE_BOOKING_FAILURE,
});

export default hideBookingFailure;
